
import type { ReplaceParams } from 'app/dataTypes/dishes/saleType'
import type { Request } from '../../../index'


type ApiParams = {
  sale_types: Array<{
    id: number
    replace_id: number | null
  }>
}

export const convertParams = (params: ReplaceParams): [ApiParams, null] => {
  return [{ sale_types: params.map(({ id, replaceId }) => ({
    id: parseInt(id, 10),
    replace_id: replaceId ? parseInt(replaceId, 10) : null,
  })) }, null]
}

export const convertResult = (): true => {
  return true
}

export const POST_SALE_TYPES_REPLACE: Request<
  ReplaceParams,
  true,
  null
> = [
  'food/items/delete_and_replace_sale_types',
  'post',
  ['data', 'result'],
]
